import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';

function useAvatarOverlay() {
  // Hooks
  const data = useStaticQuery(graphql`
    query {
      avatarOverlay: file(relativePath: { eq: "peopleOverlay.png" }) {
        childImageSharp {
          fluid(quality: 80, maxWidth: 1920) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `);

  const fluid = React.useMemo(() => {
    if (data && data.avatarOverlay) {
      return data.avatarOverlay;
    }
    return null;
  }, [data]);

  return {
    fluid,
    data,
  };
}

export default useAvatarOverlay;
